import { LiveAudioVisualizerCanvas } from './LiveAudioVisualizerCanvas/LiveAudiVisualizerCanvas';
import clsx from 'clsx';

import type { LiveAudioVisualizerV2Props } from './LiveAudioVisualizerV2.types';
import classes from './LiveAudioVisualizerV2.module.css';
import useComputedStyle from '../../hooks/useComputedStyle';

export const LiveAudioVisualizerV2 = (props: LiveAudioVisualizerV2Props) => {
    const { pcmChunks, width, height, barColor, className } = props;

    const { elementRef, computedStyles } = useComputedStyle();

    return (
        <div className={clsx(classes.root, className)}>
            <span ref={elementRef} className={classes.styleReference}>
                style reference
            </span>
            <LiveAudioVisualizerCanvas
                pcmChunks={pcmChunks}
                width={width ?? computedStyles.width }
                height={height ?? computedStyles.height}
                gap={3}
                barColor={barColor ?? computedStyles.color}
            />
        </div>
    );
};

LiveAudioVisualizerV2.displayName = 'LiveAudioVisualizerV2';